import React from 'react';
import { motion } from 'framer-motion';
import styles from './QuestionAndAdvt.module.css';

import logo from '../../assets/images/logo.png';

import left from '../../assets/images/left.png';
import right from '../../assets/images/right.png';

import posterDefault from '../../assets/images/poster.png';
import bgDefaultVideo from '../../assets/video/bgVideo.mp4';
import { useGetParams } from '../../hooks/useGetParams';

function QuestionAndAdvt({ question, questionFontSize, bgVideo, bgPoster }) {
  const questionArr = question.split('\n').map((el) => el.replace('\r', ''));

  const {
    paddingQR,
    sizeQR,
    title,
    titleFontSize,
    qrCode1,
    qrTitle1,
    qrCode2,
    qrTitle2,
  } = useGetParams();

  const titleArr = title.split('\\n');

  const colorBorders = {
    telegram: '#069ef2',
    whatsapp: '#25d366',
    max: '#9541dd',
  };

  return (
    <div className={styles.questionWrapper}>
      <motion.img
        src={logo}
        alt="logo"
        className={styles.logo}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      />

      <motion.div
        className={styles.questionBlock}
        initial={{ y: '40vh', scale: 1 }}
        animate={{ y: 0, scale: 0.8, originY: 0 }}
        transition={{ duration: 1, delay: 2.8 }}
      >
        {questionArr[0] && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.4, 1] }}
            transition={{ times: [0, 0.85, 1], duration: 1.5 }}
          >
            <div className={styles.firstLine}> {questionArr[0]}</div>
          </motion.div>
        )}
        {questionArr[1] && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.2, 0.95] }}
            transition={{ times: [0, 0.85, 1], duration: 1.66, delay: 0.43 }}
          >
            <div className={styles.secondLine}>{questionArr[1]}</div>
          </motion.div>
        )}
        {questionArr[2] && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.2, 0.9] }}
            transition={{ times: [0, 0.85, 1], duration: 1.66, delay: 0.93 }}
          >
            <div className={styles.thirdLine}>{questionArr[2]}</div>
          </motion.div>
        )}
      </motion.div>

      <div className={styles.qrsContainer}>
        {qrCode1 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1, 0.9, 1] }}
            transition={{
              duration: 1.33,
              delay: 4,
              times: [0, 0.75, 0.87, 1],
            }}
            className={styles.qrBlock}
            style={{ borderColor: colorBorders[qrTitle1?.toLowerCase()] }}
          >
            <img
              src={qrCode1}
              alt="qrCode1"
              className={styles.qrCode}
              style={{
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
                padding: `${paddingQR}rem`,
              }}
            />
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1, 0.9, 1] }}
            transition={{
              duration: 1.33,
              delay: 4,
              times: [0, 0.75, 0.87, 1],
            }}
            className={styles.qrBlock}
            style={{ borderColor: colorBorders[qrTitle2?.toLowerCase()] }}
          >
            <img
              src={qrCode2}
              alt="qrCode1"
              className={styles.qrCode}
              style={{
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
                padding: `${paddingQR}rem`,
              }}
            />
          </motion.div>
        )}
      </div>

      <motion.div
        initial={{ y: '30vh', opacity: 0 }}
        animate={{
          y: 0,
          opacity: 1,
          transition: {
            y: {
              duration: 1.33,
              delay: 5.33,
              ease: 'easeInOut',
            },
            opacity: {
              duration: 0.1,
              delay: 5.23,
              ease: 'easeInOut',
            },
          },
        }}
        className={styles.titleBlock}
      >
        {titleArr.map((str) => (
          <div
            key={str}
            className={styles.titleItem}
            style={{
              fontSize: `${titleFontSize}rem`,
              lineHeight: `${titleFontSize}rem`,
            }}
          >
            {str}
          </div>
        ))}
      </motion.div>

      <motion.img
        src={left}
        initial={{ x: '-50%', y: '-2%' }}
        animate={{ x: '-20%', y: '0' }}
        transition={{ duration: 1, ease: 'easeOut' }}
        alt="playerLeft"
        className={styles.left}
      />

      <motion.img
        src={right}
        initial={{ x: '50%', y: '-2%' }}
        animate={{ x: '0%', y: '0' }}
        transition={{ duration: 1, ease: 'easeOut' }}
        alt="playerRight"
        className={styles.right}
      />

      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        className={styles.videoBg}
        poster={bgVideo === '1' ? posterDefault : bgPoster}
      >
        <source
          src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
          type="video/mp4"
        ></source>
      </video>
    </div>
  );
}

export default QuestionAndAdvt;
